<template>
  <ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-ad-placements'"
              :title="
                getTitle ? `${getTitle} рекламное место` : `Создать рекламное место`
              "
            />
          </v-card-title>
          <v-card-text>
            <PageContent height="85">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span>Название рекламного места *</span>
                    <v-text-field
                      id="title"
                      v-model="fields.title"
                      outlined
                      :disabled="disabled"
                      :loading="loading"
                      :error-messages="validationErrors.title"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>ID *</span>
                    <v-text-field
                      id="slotId"
                      v-model="fields.slotId"
                      outlined
                      :loading="loading"
                      :disabled="disabled"
                      :error-messages="validationErrors.slotId"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Ширина *</span>
                    <v-text-field
                      id="width"
                      v-model.trim="fields.width"
                      outlined
                      :loading="loading"
                      :disabled="disabled"
                      :error-messages="validationErrors.width"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Высота *</span>
                    <v-text-field
                      id="height"
                      v-model.trim="fields.height"
                      outlined
                      :disabled="disabled"
                      :loading="loading"
                      :error-messages="validationErrors.height"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Iframe URL *</span>
                    <v-text-field
                      id="url"
                      v-model="fields.url"
                      outlined
                      :disabled="disabled"
                      :loading="loading"
                      :error-messages="validationErrors.url"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Комментарий</span>
                    <v-text-field
                      v-model="fields.note"
                      outlined
                      :disabled="disabled"
                      :loading="loading"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          ref="manageSidePanel"
          :is-new="isNew"
          :isLocales="false"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :entity-id="data.id"
          :entity-type="'adPlacement'"
          @delete="$emit('delete-ad-placement')"
          @cancel="$router.push({ name: 'page-ad-placements' })"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </form>
</template>
<script>
import validationRules from './validation-rules.js'
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import FormHeader from '@/components/form-header'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'FormPageAdPlacement',
  validationRules,
  components: {
    PageContent,
    ManageSidePanel,
    FormHeader,
    ProgressCircular
  },
  extends: FormAbstract,
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: {
        title: null,
        slotId: null,
        height: null,
        width: null,
        url: null,
        note: null
      }
    }
  },
  computed: {
    getTitle () {
      if (this.data) {
        return this.data?.title || ''
      }
      return null
    }
  },
  watch: {
    data (data) {
      this.populate(data)
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      this.$emit('submit', {
        data: payload
      })
    }
  }
}
</script>
